import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=271f4f21&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
import style0 from "./Block.vue?vue&type=style&index=0&id=271f4f21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports